import { Group, Indicator, Select, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useLocalAgent } from "../hooks/useLocalAgent";

export function StationSelector() {
  const { t } = useTranslation();
  const { agents, selectedId, select, status } = useLocalAgent();
  if (agents.length === 0) return null;
  if (agents.length === 1) {
    return (
      <Group gap={6} wrap="nowrap">
        <Indicator color={status.available ? "green" : "gray"} size={8} />
        <Text size="sm" c="dimmed" style={{ whiteSpace: "nowrap" }}>
          {agents[0].name}
        </Text>
      </Group>
    );
  }
  return (
    <Select
      size="xs"
      w={{ base: 120, xs: 160 }}
      aria-label={t("station.select")}
      placeholder={t("station.select")}
      data={agents.map((a) => ({ value: a.agent_id, label: a.name }))}
      value={selectedId}
      onChange={(v) => select(v)}
      allowDeselect={false}
      comboboxProps={{ withinPortal: true }}
    />
  );
}
